(function ($) {
    if ($(".thriving-together-theater-page").length > 0) {
        $(".left-sector").on("mouseover", function () {
            $(".image-left-active").addClass("visible");
        })

        $(".left-sector").on("mouseleave", function () {
            $(".image-left-active").removeClass("visible");
        })

        $(".right-sector").on("mouseover", function () {
            $(".image-right-active").addClass("visible");
        })

        $(".right-sector").on("mouseleave", function () {
            $(".image-right-active").removeClass("visible");
        })
    }
})(jQuery);